"use client";

import React, { createContext, useContext, useMemo } from "react";
import { defaultLocale } from "@/config";

export type ChannelContextValue = {
	channelLanguageMap: Record<string, string>;
	getChannel: (locale?: string) => string;
};

const defaultGetChannel = () => "default-channel";

export const ChannelContext = createContext<ChannelContextValue>({
	channelLanguageMap: { [defaultLocale]: "default-channel" },
	getChannel: defaultGetChannel,
});

/** @deprecated 使用 ChannelContext */
export const UserContext = ChannelContext;

export function useChannel(locale?: string) {
	const ctx = useContext(ChannelContext);
	const channel = useMemo(() => ctx.getChannel(locale), [ctx, locale]);
	return { channel, channelLanguageMap: ctx.channelLanguageMap, getChannel: ctx.getChannel };
}

type Props = {
	children: React.ReactNode;
	channelLanguageMap: Record<string, string>;
};

export default function Channel({ children, channelLanguageMap }: Props) {
	const value = useMemo<ChannelContextValue>(() => {
		const getChannel = (loc?: string) => {
			const l = loc ?? defaultLocale;
			return channelLanguageMap[l] ?? channelLanguageMap[defaultLocale] ?? "default-channel";
		};
		return { channelLanguageMap, getChannel };
	}, [channelLanguageMap]);

	return <ChannelContext.Provider value={value}>{children}</ChannelContext.Provider>;
}
